<template>
  <v-dialog v-model="value" max-width="400" :dark="dark">
    <v-card :color="color">
      <v-card-title />
      <v-card-text class="text-subtitle-1 ">
        {{ cantOrderText }}
        {{ cantOrderTime }}
      </v-card-text>
      <v-card-text>
        <Button title="close" sub-button @click="close" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogMixin from '@/components/dialogs/DialogMixin';
import Button from '@/components/Button';

export default {
  name: 'OutOfOrderTime',
  components: { Button },
  mixins: [DialogMixin],
  computed: {
    cantOrderTime() {
      const { point, points } = this.$store.state.data;
      return this.$tools.time.range(
        points[point].order_time_range[0],
        points[point].order_time_range[1]
      );
    },
    cantOrderText() {
      const { settings } = this.$store.state.data;
      return settings.order_text_off || this.$dictionary.get('cannot-order');
    }
  }
};
</script>
